import { TamperEventsGetRequestParams } from "@lib/core";

export interface TamperEventDefaultParams extends TamperEventsGetRequestParams { }
export class TamperEventDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}